import { format } from 'date-fns';
import ListActions from '../../../components/list-actions/list-actions.componenet';
import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import TableCellStatus from '../../../components/table-cell-status/table-cell-status.component';
import { useMediaQuery } from 'react-responsive';

import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../../utils/column-values.util';
import { formatNumberToTwoDecimal } from '../../../utils/format-number.util';

const ENDPOINT = "/items";

export const ITEM_ORDERS_COLUMNS = [
    {
        Header: "Product Code",
        accessor: "itemCode",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "Product Name",
        accessor: "itemName",
        Cell: ({ value }) => {
            return displayCellValue(value);
        }
    },
    {
        Header: "Quantity On Hand",
        accessor: "totalQtyOnHand",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });
            const isRightAligned = true;

            if (!value) {
                return displayCellValue(value);
            }

            value.label = value && value.label && isNaN(value.label) ?
                value.label :
                !isMobileView ? formatNumberToTwoDecimal(value.label) : `${formatNumberToTwoDecimal(value.label)} Quantity`


            return (
                <div className={isMobileView && isRightAligned ?
                    'list-table__body__row__cell--right-aligned-mobile-cell' : ''}>
                    <TableCellStatus
                        value={value}
                        noDot={true}
                    />
                </div>
            );
        }
    },
    {
        Header: "Category",
        accessor: "itemGroupCode",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return null;
            }

            return displayCellValue(value);
        }
    },
    {
        Header: "Unit Price (ETB)",
        accessor: "unitSellingPrice",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `Price: ${value ? displayCellValueNumberToTwoDecimal(value) : 0} ETB`;
            }

            return displayCellValueNumberToTwoDecimal(value);
        }
    },
]